module.exports = __webpack_public_path__ + "assets/images/novasports_extra1.5be9bd5c59292c31c0d74dc03e0690e5.png";